import {
    // Button,
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    Input,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
// import { SaveIcon } from 'lucide-react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { TextField } from '@/components/form/fields';
import { DeleteButton } from '@/components/ui/button';
import { formatCurrencyInBDT } from '@/utils/currency-formater';

import { useWholesaleOrderRequestDetailsContext } from './context';
import { ConfirmOrderForm } from './schema';

export const ProductsTable = () => {
    const { isLoading } = useWholesaleOrderRequestDetailsContext();

    const { control, watch, register, formState } =
        useFormContext<ConfirmOrderForm>();

    const { dirtyFields, touchedFields } = formState;

    console.log('Dirty Fields:', dirtyFields, 'Touched Fields:', touchedFields);

    const { remove } = useFieldArray({
        control,
        name: 'items',
    });

    const formItems = watch('items');

    const calculateTotalPrice = () => {
        const total = formItems.reduce((total, item) => {
            return total + item.wholesale_price * item.quantity;
        }, 0);

        return Math.round(total);
    };

    if (isLoading) {
        return <p>Loading...</p>;
    }

    const renderTableRows = () => {
        return (
            formItems &&
            formItems.length > 0 &&
            formItems.map((item, index) => (
                <TableRow key={index}>
                    <TableCell className="font-medium">
                        {item.product_name || 'N/A'}
                    </TableCell>
                    <TableCell className="text-right">
                        {item.available_quantity}
                    </TableCell>
                    <TableCell className="flex items-center justify-end px-0 py-0 text-right">
                        <Input
                            {...register(`items.${index}.quantity`)}
                            className="w-20 px-2 py-0.5 text-right"
                        />{' '}
                    </TableCell>
                    <TableCell className="text-right">
                        {item.purchase_price}
                    </TableCell>
                    <TableCell className="text-right">
                        {item.wholesale_price}
                    </TableCell>
                    <TableCell className="text-right">
                        {item.retail_price}
                    </TableCell>
                    <TableCell className="text-right">
                        {formatCurrencyInBDT(
                            item.wholesale_price * item.quantity,
                        )}
                    </TableCell>
                    <TableCell className="flex justify-end gap-2 text-right">
                        <DeleteButton
                            isIconButton
                            size={'icon'}
                            label="Cancel"
                            onClick={() => {
                                remove(index);
                            }}
                        />
                    </TableCell>
                </TableRow>
            ))
        );
    };

    return (
        <Card>
            <CardHeader>
                <div className="flex items-center justify-between">
                    <CardTitle>Request Items</CardTitle>
                    {/* <div>
                        <Button
                            disabled={isDirty}
                            variant={'outline'}
                            size={'sm'}
                        >
                            <SaveIcon className="disabled" />
                        </Button>
                    </div> */}
                </div>
            </CardHeader>
            <CardContent className="">
                <Table className="-mx-4">
                    <TableHeader>
                        <TableRow>
                            <TableHead className="">Name</TableHead>
                            <TableHead className="text-right">Stock</TableHead>
                            <TableHead className="text-right">
                                Quantity
                            </TableHead>
                            <TableHead className="text-right">PP</TableHead>
                            <TableHead className="text-right">WP</TableHead>
                            <TableHead className="text-right">MRP</TableHead>
                            <TableHead className="text-right">
                                Sub-Total
                            </TableHead>
                            <TableHead className="text-right">
                                Actions
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>{renderTableRows()}</TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={6}>Total</TableCell>
                            <TableCell className="text-right">
                                {formatCurrencyInBDT(calculateTotalPrice())}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Paid Amount: </TableCell>
                            <TableCell className="text-right">
                                <TextField<ConfirmOrderForm>
                                    name="paid_amount"
                                    placeholder="Enter paid amount"
                                    inputClass="text-right"
                                />
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </CardContent>
        </Card>
    );
};
